import React, { useRef } from 'react';
import { View, LayoutChangeEvent } from 'react-native';
import { SizeLimitContext } from 'src/contexts/SizeLimitContext';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export const ContainerPreviewV3 = ({
  children,
  shouldUseContainerDimensions,
  onContainerDimensionsChange,
}: {
  children: React.ReactNode;
  shouldUseContainerDimensions?: boolean;
  onContainerDimensionsChange?: (dimensions: { width: number; height: number }) => void;
}) => {
  const containerRef = useRef<View>(null);
  const { isMobile } = useResponsiveScreen();

  const handleLayout = (event: LayoutChangeEvent) => {
    const dimensions = event.nativeEvent.layout;
    onContainerDimensionsChange?.(dimensions);
  };
  if (shouldUseContainerDimensions) {
    return (
      <View style={[{ width: '100%', height: '100%' }]}>
        <View
          ref={containerRef}
          style={{ width: '100%', height: '100%', justifyContent: isMobile ? 'center' : undefined }}
          onLayout={handleLayout}
        >
          <SizeLimitContext.Provider value={{ width: 0, height: 0 }}>{children}</SizeLimitContext.Provider>
        </View>
      </View>
    );
  } else {
    return children;
  }
};
